import BehamrahCoreApp from "@package/behamrah-core/dist/App";

import config from "./config";

const App = () => <BehamrahCoreApp config={config} />;

export default App;
